import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  CTA: {
    id: 'label_cta',
    defaultMessage: 'Call to Action',
  },
  Title: {
    id: 'label_title',
    defaultMessage: 'Title',
  },
  Media: {
    id: 'label_media',
    defaultMessage: 'Media',
  },
  Actions: {
    id: 'label_actions',
    defaultMessage: 'Actions',
  },
  Contact: {
    id: 'label_contact',
    defaultMessage: 'Contact',
  },
  ContactHelp: {
    id: 'help_contact',
    defaultMessage:
      'If selected and not overridden above, data is pulled from the selected contact.',
  },
  Address: {
    id: 'Address',
    defaultMessage: 'Address',
  },
});
